<div mat-dialog-title class="cust-modal-title">
  <h2 class="m-0">{{ parentData.title }}</h2>
  <button mat-icon-button mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-dialog-content style="padding-bottom: 30px;">

  <!-- Card -->
 <mat-card class="invite-card">

    <!-- <h3 class="section-title">Send Invitations</h3> -->

    <!-- Toggle -->
  <div class="toggle-group">

  <!-- WhatsApp -->
  <button
    mat-flat-button
    class="toggle-btn"

    [ngClass]="{'active': selectedValue == '1'}" (click)="changeChip('1')"
  >
    <!-- WhatsApp SVG -->
    <span class="icon">
    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 682 682.667" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path fill-rule="evenodd" d="M544.387 93.008C484.512 33.063 404.883.035 320.05 0 145.246 0 2.98 142.262 2.91 317.113c-.024 55.895 14.577 110.457 42.331 158.551L.25 640l168.121-44.102c46.324 25.27 98.477 38.586 151.55 38.602h.134c174.785 0 317.066-142.273 317.132-317.133.036-84.742-32.921-164.418-92.8-224.36zM320.05 580.94h-.11c-47.296-.02-93.683-12.73-134.16-36.742l-9.62-5.715-99.766 26.172 26.628-97.27-6.27-9.972c-26.386-41.969-40.32-90.476-40.296-140.281.055-145.332 118.305-263.57 263.7-263.57 70.406.023 136.59 27.476 186.355 77.3s77.156 116.051 77.133 186.485C583.582 462.69 465.34 580.94 320.05 580.94zm144.586-197.418c-7.922-3.968-46.883-23.132-54.149-25.78-7.258-2.645-12.547-3.962-17.824 3.968-5.285 7.93-20.469 25.781-25.094 31.066-4.625 5.29-9.242 5.953-17.168 1.985-7.925-3.965-33.457-12.336-63.726-39.332-23.555-21.012-39.457-46.961-44.082-54.89-4.617-7.938-.04-11.813 3.476-16.173 8.578-10.652 17.168-21.82 19.809-27.105 2.644-5.29 1.32-9.918-.664-13.883-1.977-3.965-17.824-42.969-24.426-58.84-6.437-15.445-12.965-13.36-17.832-13.601-4.617-.231-9.902-.278-15.187-.278-5.282 0-13.868 1.98-21.133 9.918-7.262 7.934-27.73 27.102-27.73 66.106s28.394 76.683 32.355 81.972c3.96 5.29 55.879 85.328 135.367 119.649 18.906 8.172 33.664 13.043 45.176 16.695 18.984 6.031 36.254 5.18 49.91 3.14 15.226-2.277 46.879-19.171 53.488-37.68 6.602-18.51 6.602-34.374 4.617-37.683-1.976-3.304-7.261-5.285-15.183-9.254zm0 0"    fill="currentColor"
        fill-rule="evenodd" data-original="#000000" class=""></path></g></svg>
    </span>
    Intimate via WhatsApp
  </button>

  <!-- Email -->
  <button mat-flat-button class="toggle-btn" [ngClass]="{'active': selectedValue == '2'}" (click)="changeChip('2')">
    <span class="icon">
     <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M467 76H45C20.238 76 0 96.149 0 121v270c0 24.86 20.251 45 45 45h422c24.762 0 45-20.149 45-45V121c0-24.857-20.248-45-45-45zm-6.91 30L267.624 299.094c-5.864 5.882-17.381 5.886-23.248 0L51.91 106h408.18zM30 385.485v-258.97L159.065 256 30 385.485zM51.91 406l128.334-128.752 42.885 43.025c17.574 17.631 48.175 17.624 65.743 0l42.885-43.024L460.09 406H51.91zM482 385.485 352.935 256 482 126.515v258.97z"  fill="currentColor" opacity="1" data-original="#000000" class=""></path></g></svg>
    </span>
    Intimate via Email
  </button>
</div>
    <!-- WhatsApp -->
    <div *ngIf="selectedValue == '1'" class="form-section">
      <mat-form-field appearance="outline" class="country">
        <mat-label>Country Code</mat-label>
                        <mat-select
                        [(ngModel)]="selectedCountryCode"
                        required
                        (selectionChange)="onCountrySelected($event)"
                      >
                        <mat-select-trigger>
                                      
                              {{ "(" + selectedCountryCode.dial_code + ")" }}
                        </mat-select-trigger>
                        
                        <mat-option>
                          <ngx-mat-select-search
                            noEntriesFoundLabel="no results found"
                            name="countrysearch"
                            placeholderLabel="Enter country name"
                            [formControl]="searchString"
                            (keyup)="onKey()"
                          ></ngx-mat-select-search>
                        </mat-option>
                        <mat-option *ngFor="let country of countryList" [value]="country">
                          {{ country.flag }} {{ country.name }}
                          {{ "(" + country.dial_code + ")" }}
                        </mat-option>
                      </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="mobile">
        <mat-label>Enter number</mat-label>
        <input matInput [(ngModel)]="whatsappNumbers"/>
      </mat-form-field>
   <div class="send_btn_yty">
      <button mat-flat-button class="send-btn" (click)="send()" [disabled]="checkdis()">
        Send
      </button>
      </div>
    </div>

    <!-- Email -->
    <div *ngIf="selectedValue == '2'" class="form-section">
      <mat-form-field appearance="outline" class="full">
        <mat-label>
          Enter email id.
        </mat-label>
        <input matInput [(ngModel)]="emailAddresses" />
      </mat-form-field>
     <div class="send_btn_yty">
      <button mat-flat-button class="send-btn" (click)="send()" [disabled]="checkdis()">
        Send
      </button>
      </div>
    </div>

  </mat-card>
  <div class="share-divider">
  <span class="share-divider__text">OR</span>
</div>
  <!-- end design end -->
      <mat-form-field appearance="outline" style="width: 100%">
        <textarea [(ngModel)]="msg" matInput #userinput spellcheck="false" readonly></textarea>
      </mat-form-field>
      <button mat-flat-button color="accent" *ngIf="copied" style="    margin-left: 0px;
      height: 50px;
      position: relative;
      top: 0;
      color:#fff;
      width: 100%;">  <mat-icon style="margin-right: 5px;" class="material-icons-round" [inline]="true"
      >done</mat-icon
    >Copied
    </button>
      <button
      *ngIf="!copied"
      mat-button 
      style=" border: 1px solid #FFC107;
    margin-left: 0;
    height: 50px;
    position: relative;
    top: 0;
    width: 100%;
    color: #FFC107;"
      (click)="copyInputMessage(userinput)"
    >
      Copy
    </button>

    <!-- <textarea type="text" [(ngModel)]="msg" #userinput></textarea> -->
    <!-- <a href="javascript:void(0)" (click)="copyInputMessage(userinput)">
      <span id="link-copy">Copy Link</span>
    </a> -->
</mat-dialog-content>
